<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">

      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">View Activity Details
            <div class="text-right">
              <md-button @click="goToEdit(activity.id)" class="md-primary md-dense">
                <md-icon>edit</md-icon>
                Edit Activity
              </md-button>
              <md-button @click="goBack" class="md-primary md-dense">Back to List</md-button>
            </div>
          </h4>
        </md-card-header>
        <md-card-content>
          <div>
            <div class="md-layout">
              <div class="md-layout-item md-size-100 mt-4 md-small-size-100">
                <md-card-content>
                  <md-table v-model="tableData">
                    <md-table-row>
                      <md-table-cell>Name:</md-table-cell>
                      <md-table-cell>{{ activity.name }}</md-table-cell>
                    </md-table-row>
                    <md-table-row>
                      <md-table-cell>Category:</md-table-cell>
                      <md-table-cell>{{ activity.category.name }}</md-table-cell>
                    </md-table-row>
                    <md-table-row>
                      <md-table-cell>Description:</md-table-cell>
                      <md-table-cell>{{ activity.description }}</md-table-cell>
                    </md-table-row>
                    <md-table-row>
                      <md-table-cell>Payment Mode:</md-table-cell>
                      <md-table-cell>{{ activity.payment_mode }}</md-table-cell>
                    </md-table-row>
                    <md-table-row>
                      <md-table-cell>Payment Code:</md-table-cell>
                      <md-table-cell> {{ activity.pay_code }}</md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </div>
            </div>
          </div>


        </md-card-content>
      </md-card>
    </div>
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>eye</md-icon>
          </div>
          <h4 class="title">Activity Details</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <nav-tabs-card>
              <template slot="content">
                <span class="md-nav-tabs-title">Details:</span>
                <md-tabs class="md-info" md-alignment="left">
                  <md-tab id="tab-home" md-label="Skills" md-icon="bug_report">
                    <div class="md-layout-item md-small-size-100">
                      <form @submit.prevent="add">
                        <md-card>
                          <md-card-header class="md-card-header-icon md-card-header-green">
                            <div class="card-icon md-xsmall-size">
                              <md-icon>face</md-icon>
                            </div>
                            <h5 class="title">Add Skills</h5>
                            <hr>

                          </md-card-header>
                          <md-card-content>
                            <div class="md-layout">
                              <label class="md-layout-item md-size-25 md-form-label">
                                Skill Category
                              </label>
                              <div class="md-layout-item">
                                <select-input
                                    v-model="skill_category_id"
                                    deselect-label="Can't remove this value"
                                    track-by="id"
                                    label=" "
                                    placeholder="Select Category"
                                    :options="category_lists"
                                    :allow-empty="false"
                                >
                                </select-input>
                              </div>
                            </div>
                            <div class="md-layout" v-if="skill_category_id">
                              <label class="md-layout-item md-size-25 md-form-label">
                                Skills
                              </label>
                              <div class="md-layout-item">
                                <multiselect
                                    v-model="permission.selected"
                                    deselect-label="Can't remove this value"
                                    track-by="name"
                                    :multiple="true"
                                    label="name"
                                    placeholder="Select"
                                    :options="skillsLists"
                                    :searchable="true"
                                    :allow-empty="false"
                                >
                                </multiselect>
                              </div>
                            </div>
                          </md-card-content>
                          <md-card-actions md-alignment="right">
                            <md-button type="submit" class="md-success">Add Skills</md-button>
                          </md-card-actions>
                        </md-card>
                      </form>
                    </div>

                    <md-table>
                      <md-table-row>
                        <md-table-head>#</md-table-head>
                        <md-table-head>Skill</md-table-head>
                        <md-table-head>Category</md-table-head>
                        <md-table-head>Actions</md-table-head>
                      </md-table-row>

                      <md-table-row
                          v-for="(skill, index) in activity.skills"
                          :key="skill.id"
                      >
                        <md-table-cell>
                          {{ index + 1 }}
                        </md-table-cell>

                        <md-table-cell>
                          {{ skill.name }}
                        </md-table-cell>

                        <md-table-cell>
                          {{ skill.skill_category_name }}
                        </md-table-cell>

                        <md-table-cell>
                          <!--                                            <md-button-->
                          <!--                                                class="md-info md-just-icon md-simple"-->
                          <!--                                                @click="editSkill(skill)"-->
                          <!--                                            >-->
                          <!--                                              <md-icon>edit</md-icon>-->
                          <!--                                            </md-button>-->

                          <md-button
                              class="md-danger md-just-icon md-simple"
                              @click="detachSkill(activity.id, skill.id)"
                          >
                            <md-icon>delete</md-icon>
                          </md-button>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </md-tab>
                </md-tabs>
              </template>
            </nav-tabs-card>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import SelectInput from '../../../components/Inputs/SelectInput';
import Multiselect from 'vue-multiselect';
import {NavTabsCard,} from '@/components';
import _ from 'lodash';
import Swal from "sweetalert2";


export default {
  components: {
    NavTabsCard,
    SelectInput,
    Multiselect,
  },
  data() {
    return {
      category_lists: [],
      skill_category_id: null,
      tableData: [],
      activity: {
        type: 'activities',
        name: null,
        description: null,
        payment_mode: null,
        pay_code: null,
        skills: [],
        category: {
          id: null,
          type: 'categories',
        },
        relationshipNames: ['category', '"skills'],
      },
      available_categories: [],
      firstTabs: [
        {
          tab: 'Sign contract for "What are conference organizers afraid of?"'
        },
        {
          tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
        },
        {
          tab:
              'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
        }
      ],
      secondTabs: [
        {
          tab: 'Sign contract for "What are conference organizers afraid of?"'
        },
        {
          tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
        },
        {
          tab:
              'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
        }
      ],
      thirdTabs: [
        {
          tab: 'Sign contract for "What are conference organizers afraid of?"'
        },
        {
          tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
        },
        {
          tab:
              'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
        }
      ],
      fourthTabs: [
        {
          tab: 'Sign contract for "What are conference organizers afraid of?"'
        },
        {
          tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
        },
        {
          tab:
              'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
        }
      ],

      query: null,

      sortation: {
        field: 'created_at',
        order: 'asc',
      },

      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
      },

      total: 0,
      permission: {
        type: 'vendors',
        selected: [],
      },
      skillsLists: [],
      selected_permission: [],
      perm_names: [],
      activitySkill: {
        type: 'activitySkills',
        activity_id: null,
        skill_id: null
      }
    };
  },
  created() {
    this.get();
    this.getCategories();
    this.getSkillsCategories();
  },

  methods: {

    async add() {
      if (this.permission.selected.length > 0) {
        this.permission.selected.forEach(perm_d => {
          //  this.activity.skills.push(perm_d.id);
        });
        // await this.$store.dispatch('activities/update', this.activity);
        // await this.$store.dispatch('activitySkills/add', this.activity);
        //
        for (const perm of this.permission.selected) {
          this.activitySkill.activity_id = this.activity.id;
          this.activitySkill.skill_id = perm.id;
          await this.$store.dispatch('activitySkills/add', this.activitySkill);
        }
        this.permission.selected = [];
        this.notifySuccess('Activity Updated successfully')
        this.$router.get();
      } else {
        await this.$store.dispatch(
            'alerts/error',
            'Please select  at least one Skill'
        );
      }
    },

    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch('activities/get', id);
        this.activity = this.$store.getters['activities/activity1'];
      } catch (e) {
        await this.$store.dispatch(
            'alerts/error',
            'Oops, something went wrong!'
        );
      }
    },
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    async getList() {
      let params = {
        ...(this.sort ? {sort: this.sort} : {}),
        filter: {
          ...(this.query ? {name: this.query} : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage,
        },
      };
      try {
        await this.$store.dispatch('vendors/employees', {
          vendor: this.vendor,
          params: params
        });
        this.table = this.$store.getters['vendors/list'];
        this.total = this.$store.getters['vendors/listTotal'];
      } catch (e) {
        await this.$store.dispatch(
            'alerts/error',
            'Oops, something went wrong!'
        );
      }
    },
    getCategories() {
      this.$store.dispatch('categories/list').then(() => {
        this.available_categories = this.$store.getters['categories/dropdown'];
      });
    },
    goBack() {
      this.$router.push({name: 'Activities List'});
    },
    goToEdit(id) {
      this.$router.push({name: 'Edit Activity', params: {id}});
    },
    async getSkillsCategories() {
      await this.$store.dispatch('skillCategories/list');
      this.category_lists = this.$store.getters['skillCategories/list'];
    },
    async detachSkill(activityId, skillId) {
      const confirmation = await Swal.fire({
        title: 'Detach this Skill?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, detach it!',
        cancelButtonText: 'No, keep it',
        confirmButtonClass: 'md-button md-success',
        cancelButtonClass: 'md-button md-danger',
      });

      if (confirmation.value === true) {
        try {

          await this.$store.dispatch('activities/detachSkill', {
            activityId: activityId,
            skillId: skillId
          });
          await this.$store.dispatch(
              'alerts/success',
              'Skill detached successfully.'
          );
          await this.get();
        } catch (e) {
          if (e.response.data.errors[0]) {
            await this.$store.dispatch(
                'alerts/error',
                e.response.data.errors[0].title
            );
          } else {
            this.notifyException(e);
          }
        }
      }
    },
    // async detachSkill(activityId, skillId) {
    //   try {
    //     await this.$store.dispatch('activities/detachSkill', {
    //       activityId: activityId,
    //       skillId: skillId
    //     });
    //
    //     this.$notify({
    //       type: "success",
    //       message: "Skill removed from activity"
    //     });
    //
    //     //await this.get();
    //   } catch (e) {
    //     console.error(e);
    //   }
    // }
  },

  computed: {
    shoppingTotal() {
      return this.shoppingCartTable.reduce((accumulator, current) => {
        return accumulator + current.amount;
      }, 0);
    },
    skillData() {
      return this.skill_category_id;
    },

  },
  watch: {
    async skillData() {
      await this.$store.dispatch('skillCategories/get', this.skill_category_id);
      let category = this.$store.getters['skillCategories/skillCategory'];
      this.permission.selected = [];
      await this.$store.dispatch('skillCategories/skills', {
        category: category,
        params: {}
      });
      this.skillsLists = this.$store.getters['skillCategories/list'];
    },
  },

};
</script>
<style lang="scss" scoped>
.text-right .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}

.md-table .md-table-head:last-child {
  text-align: right;
}

.table-stats {
  display: flex;
  align-items: center;
  text-align: right;
  flex-flow: row wrap;

  .td-price .td-total {
    display: inline-flex;
    font-weight: 500;
    font-size: 1.0625rem;
    margin-right: 50px;
  }

  &.table-striped .td-price {
    border-bottom: 0;
  }

  .td-price {
    font-size: 26px;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }

  .td-price,
  > div {
    flex: 0 0 100%;
    padding: 12px 8px;
  }
}

.table-shopping .md-table-head:nth-child(5),
.table-shopping .md-table-head:nth-child(7),
.table-shopping .md-table-head:nth-child(6) {
  text-align: right;
}
</style>

